var map = {
	"./curriculumForm.vue": 5555,
	"./download-means.vue": 22756,
	"./flow-path.vue": 49421,
	"./get-past.vue": 88607,
	"./high-end-class.vue": 15053,
	"./hot-consult.vue": 43139,
	"./onlineConsult.vue": 90410,
	"./science-plan.vue": 62434,
	"./study-system.vue": 96931,
	"./suit-crowd.vue": 12129,
	"./teacher-superiority.vue": 1832,
	"./test-book.vue": 17727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63266;